module.exports = __webpack_public_path__ + "static/media/img-mulher-onboadring.e3045b33.svg";